module.exports = __webpack_public_path__ + "static/media/main-sub6.8b367f25.svg";